// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"253":"63697c31","432":"bc9e16af","630":"2a78cb6d","733":"bc9e16af"}[chunkId] + ".chunk.css";
};